import script from "./MyScore.vue?vue&type=script&setup=true&lang=js"
export * from "./MyScore.vue?vue&type=script&setup=true&lang=js"

import "./MyScore.vue?vue&type=style&index=0&id=751ab351&lang=css"

const __exports__ = script;

export default __exports__